// src/services/productService.js
import axiosClient from "./axiosClient";

const route = "product";
const productOrderRoutes = "productOrder";

// 📌 Get all products with pagination and search
export const getAllProducts = async (params) => {
  try {
    const response = await axiosClient.get(`${route}`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// 📌 Get product by ID
export const getProductById = async (productId, type) => {
  try {
    const response = await axiosClient.get(`${route}/${productId}?type=${type}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// 📌 Create new product
export const createProduct = async (productData) => {
  try {
    const response = await axiosClient.post(`${route}`, productData);
    return response;
  } catch (error) {
    throw error;
  }
};

// 📌 Update product (with transaction)
export const updateProduct = async (productId, updateData) => {
  try {
    const response = await axiosClient.put(`${route}/${productId}`, updateData);
    return response;
  } catch (error) {
    throw error;
  }
};

// 📌 Delete product
export const deleteProduct = async (productId) => {
  try {
    const response = await axiosClient.delete(`${route}/${productId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// PRODUCT ORDER ENDPOINTS
export const createProductOrder = async (orderData) => {
  try {
    const response = await axiosClient.post(`${productOrderRoutes}`, orderData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductOrders = async (params) => {
  try {
    const response = await axiosClient.get(`${productOrderRoutes}/getAll`, {
      params,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProductOrder = async (orderNumber) => {
  try {
    const response = await axiosClient.get(`${productOrderRoutes}`, {
      params: { orderNumber },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductOrder = async (updateData) => {
  try {
    const response = await axiosClient.put(`${productOrderRoutes}`, updateData);
    return response;
  } catch (error) {
    throw error;
  }
};
